import React from 'react';
import PropTypes from 'prop-types';
import styles from './list-header.module.scss';

const ListHeader = ({eyebrow, href, linkText, text}) => (
  <div className={styles.ListHeader}>
    <div>
      {eyebrow && <p className={styles.ListHeader__eyebrow}>{eyebrow}</p>}
      <h2 className={styles.ListHeader__heading}>{text}</h2>
    </div>
    {href && (
      <a className={styles.ListHeader__link} href={href}>
        {linkText} <span aria-hidden="true">&rarr;</span>
      </a>
    )}
  </div>
);

ListHeader.propTypes = {
  eyebrow: PropTypes.string,
  href: PropTypes.string,
  linkText: PropTypes.string,
  text: PropTypes.string.isRequired,
};

ListHeader.defaultProps = {
  linkText: 'View all',
};

export default ListHeader;



// WEBPACK FOOTER //
// ./src/components/ListHeader.js